<h5 class="media-title">{{feature.name}}</h5> 
<p>{{feature.description}}</p>
<p>{{'features.management.clickTo' | translate}} 
	<a href="{{feature.documentation.url}}" target="_blank" tabindex="0">{{'features.management.readDocumentation' | translate}}</a>
	<ng-container *ngIf="feature.documentation.video">,
		<a href="{{feature.documentation.video}}" target="_blank" tabindex="0">{{'features.management.watchVideo' | translate}}</a>
	</ng-container> 
</p>

       